module.exports = __webpack_public_path__ + "media/images/logos/Management-and-Science-University-f850c7141061a6cb682c6f3f447f841d.svg";